/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Document } from '../models/Document';
import { Extension } from '../models/Extension';
import { ValidationProblem } from '../models/ValidationProblem';
import { Contact } from '../models/common/Contact';
import { ExternalDocumentation } from '../models/common/ExternalDocumentation';
import { IDefinition } from '../models/common/IDefinition';
import { Info } from '../models/common/Info';
import { License } from '../models/common/License';
import { Operation } from '../models/common/Operation';
import { Parameter } from '../models/common/Parameter';
import { Schema } from '../models/common/Schema';
import { SecurityRequirement } from '../models/common/SecurityRequirement';
import { SecurityScheme } from '../models/common/SecurityScheme';
import { Tag } from '../models/common/Tag';

/**
 * A basic visitor interface used to visit data model instances.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IVisitor {
    visitContact(node : Contact);

    visitDocument(node : Document);

    visitExtension(node : Extension);

    visitExternalDocumentation(node : ExternalDocumentation);

    visitInfo(node : Info);

    visitLicense(node : License);

    visitOperation(node : Operation);

    visitParameterDefinition(node : IDefinition);

    visitParameter(node : Parameter);

    visitSchemaDefinition(node : IDefinition);

    visitSchema(node : Schema);

    visitSecurityRequirement(node : SecurityRequirement);

    visitSecurityScheme(node : SecurityScheme);

    visitTag(node : Tag);

    visitValidationProblem(problem : ValidationProblem);
}


